<div class="notifications">
  <div class="overlay" *ngIf="state.loading">
  <kng-loader [state]="loaderState"></kng-loader>
</div>
<div class="section-head">
  <h1 tabindex="0">{{state.pageHeading}}</h1>
</div>
  <div class="section-tab">
    <div class="section-tab-container">
      <div class="section-tab-labels" *ngFor="let tab of state.tabs, let i=index"
        [ngClass]="{'active': i === selectedIndex}" (click)="activateTab(i,tab.label)">
        <div class="section-tab-header">
          <button>
            {{ tab.label }}
            <div class="notification-count" *ngIf="i === selectedIndex && tab.unreadCountData !== 0">&#40;{{tab.unreadCountData}}&#41;</div>
          </button>
        </div>
      </div>
    </div>
    <div class="section-tab-mark " *ngIf="state.tabs[selectedIndex].data.length !== 0">
      <button type="button" [ngClass]="checkUnreadNotifications(service.notificationOrignalData) === 0? 'disable-class' : 'section-tab-mark'"  [disabled]="checkUnreadNotifications(service.notificationOrignalData) === 0" (click)="markAllRead()">{{state.markAsRead}} </button>
    </div>
  </div>
  <div class="section-content" *ngIf="state.tabs[selectedIndex].data.length !== 0 && state.tabs[selectedIndex].data.length !== undefined">
    <div *ngFor="let tab of state.tabs, let i=index">
      <div *ngIf="i===selectedIndex">
        <ng-container>
          <tmhna-portal-notification-content [state]="tab.data" [tabName]="tabName"  [currentPage]="pageNumber" [totalItems]="state.tabs[i].data.length" [pageSize]="state.tabs[i].pageInfo.pageSize"
          (notificationId)="getNotificationId($event)">
          </tmhna-portal-notification-content>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="pagination-container" *ngIf="state.tabs[selectedIndex].data.length !== 0" >
  <div class="show-data">
    <span class="pagination-showing" tabindex="0">Showing {{ pager.startIndex + 1 }}-{{ (state.tabs[selectedIndex].data.length) > pager.pageSize *
      (pager.currentPage) ? pager.pageSize *
      (pager.currentPage): (state.tabs[selectedIndex].data.length) | number }} of
      {{ (state.tabs[selectedIndex].data.length) | number }}</span>
  </div>
  <pagination-controls role="currentpage" (pageChange)="setPage($event)" previousLabel="" aria-controls="setPage($event)" nextLabel=""
  class="pagination-bar" [maxSize]="7" nextLabel="next" [autoHide]="true"  screenReaderPaginationLabel="Pagination Navigation" previousLabel="previous" screenReaderCurrentLabel="You are on the current Page"></pagination-controls>
</div>
<div class ="no-message-div" *ngIf="state.tabs[selectedIndex].data.length === 0 ">
  <img  src={{noMessageIcon}} alt="state.noNotification" tabindex="0">
  <p class="no-message" tabindex="0" >{{ state.noNotification }}</p>
</div>
</div>
